/**
 * 图标设计素材
 * https://www.figma.com/design/5nhAujqSeIuIoWS6kf2mqI/PikPak_%E5%AE%98%E7%BD%91_UI-Design?node-id=8191-7960&t=Mf47pz3FST8u5pTs-0
 */
import { SupportLocale } from '@/types/enum'
import { DEFAULT_LOCALE } from '~/types/constants'

export const enum ChannelCategory {
  GOOGLE_PLAY = 'google-play',
  ANDROID = 'android',
  GALAXY_STORE = 'galaxy-store',
  APP_STORE = 'app-store',
}

const localeIconImportPath = (
  locale: Lowercase<SupportLocale>,
  category: ChannelCategory,
): Promise<string | undefined> =>
  import(`../assets/images/install-channels/${category}/${locale}@2x.png`)
    .then(res => res.default)
    .catch(err => {
      console.error(err)
      return undefined
    })

export default (locale: SupportLocale) =>
  async (category: ChannelCategory): Promise<string> =>
    (await localeIconImportPath(locale.toLowerCase() as Lowercase<SupportLocale>, category)) ||
    ((await localeIconImportPath(DEFAULT_LOCALE.toLowerCase() as Lowercase<SupportLocale>, category)) as string)
